import {UbiMonthlyReportData} from '@di-shared/api/di/__generated';
import {subMonths} from 'date-fns';

export function getAverageScore(scores: number[]): number {
  if (scores.length === 0) {
    return 0;
  }
  const sum = scores.reduce((acc, val) => acc + val, 0);
  return sum / scores.length;
}

export function countMonthsAboveScore(scores: number[], threshold: number): number {
  return scores.filter((score) => score >= threshold).length;
}

export function findMinMaxDates(dateStrings: string[]): {minDate: Date | null; maxDate: Date | null} {
  if (dateStrings.length === 0) {
    return {
      minDate: null,
      maxDate: null,
    };
  }

  const dates: Date[] = dateStrings.map((dateStr) => new Date(dateStr));

  const minTimestamp = Math.min(...dates.map((date) => date.getTime()));
  const maxTimestamp = Math.max(...dates.map((date) => date.getTime()));

  return {
    minDate: new Date(minTimestamp),
    maxDate: new Date(maxTimestamp),
  };
}

export function sortByPeriod(data: UbiMonthlyReportData[]) {
  return data
    .filter(({scoreDate}) => Boolean(scoreDate))
    .sort((a, b) => {
      const dateA = new Date(a.scoreDate);
      const dateB = new Date(b.scoreDate);

      // dateA - dateB: 오름차순 (오래된 날짜가 먼저 옴)
      // dateB - dateA: 내림차순 (최신 날짜가 먼저 옴)
      return dateA.getTime() - dateB.getTime();
    });
}

export function getFallbackItems(formatDate: (date: Date) => string) {
  const today = new Date();
  const fallbackDates = Array.from({length: 6}, (_, index) => subMonths(today, 5 - index));
  return fallbackDates.map((date) => ({score: null, label: formatDate(date)}));
}
